export const imageCache = new Map<string, { url: string; blob?: Blob } | Promise<{ url: string; blob?: Blob }>>();
